export default __webpack_public_path__ + "static/media/check.7857b51d.svg";